import React from "react";
import ShippingOne from "../components/ShippingOne";
import Account from "../components/Account";
import BreadcrumbThree from "../components/BreadcrumbThree";
import { Helmet } from "react-helmet-async";


const AccountPage = () => {



  return (
    <>   

      <Helmet>
        <title> Account | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>


      {/* Breadcrumb */}
      <BreadcrumbThree title={"Account"} />

      {/* Account */}
      <Account />

      {/* ShippingOne */}
      <ShippingOne />

    </>
  );
};

export default AccountPage;
